__turbopack_context__.v({
  "blok-big-title": "ToolPDPContainer-module__60Zb1a__blok-big-title",
  "blok-subtitle": "ToolPDPContainer-module__60Zb1a__blok-subtitle",
  "blok-title": "ToolPDPContainer-module__60Zb1a__blok-title",
  "detail-container": "ToolPDPContainer-module__60Zb1a__detail-container",
  "line-clamp": "ToolPDPContainer-module__60Zb1a__line-clamp",
  "pdp-description": "ToolPDPContainer-module__60Zb1a__pdp-description",
  "pdp-details": "ToolPDPContainer-module__60Zb1a__pdp-details",
  "pdpActions": "ToolPDPContainer-module__60Zb1a__pdpActions",
  "product-name": "ToolPDPContainer-module__60Zb1a__product-name",
  "read-more": "ToolPDPContainer-module__60Zb1a__read-more",
});
